import { useEffect, useState } from "react";

export const useBMI = (height, weight) => {
  const [bmi, setBmi] = useState("");

  useEffect(() => {
    if (!height || !weight) {
      setBmi("");
      return;
    }

    const h = parseFloat(height);
    const w = parseFloat(weight);

    if (isNaN(h) || isNaN(w) || h === 0) {
      setBmi("");
      return;
    }

    const heightInMeters = h > 3 ? h / 100 : h;
    const calculatedBmi = (w / (heightInMeters * heightInMeters)).toFixed(2);

    setBmi(calculatedBmi);
  }, [height, weight]);

  return bmi;
};
